import React from 'react';
import PropTypes from 'prop-types';
import Cell from "../Cell/Cell";

Cell.propTypes = {
    text: PropTypes.string
};
Cell.defaultProps = {
    text: 'Some text'
}

function TextCell({text}) {
    return (
        <Cell title={text}>
            {text}
        </Cell>
    );
}

export default TextCell;